import { render, staticRenderFns } from "./LandingPageSubmitted.vue?vue&type=template&id=767a6146&scoped=true"
import script from "./LandingPageSubmitted.vue?vue&type=script&lang=js"
export * from "./LandingPageSubmitted.vue?vue&type=script&lang=js"
import style0 from "./LandingPageSubmitted.vue?vue&type=style&index=0&id=767a6146&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "767a6146",
  null
  
)

export default component.exports